import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from "ag-grid-community";
import {AgRendererComponent} from "ag-grid-angular";
import { IntegrationRef } from '../app.model';

@Component({
  selector: 'app-next-sync-info-render',
  templateUrl: './next-sync-info-render.component.html',
  styleUrls: ['./next-sync-info-render.component.scss']
})
export class NextSyncInfoRenderComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  userId;
  isOrgAdmin;
  innerClicked: boolean;
  isDestinationSet: boolean;


  agInit(params: ICellRendererParams): void {
      this.params = params;// console.log(this.params,"vilo")
      this.userId = this.params['userId']
      this.isOrgAdmin = this.params['isOrgAdmin']
      this.isDestinationSet = this.params.data['destinationName'] != null;
      this.innerClicked = false;

     // console.log(this.isOrgAdmin,"hello")
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`)
  }

  refresh(): boolean {
      return false;
  }

  startSource(data) {

    this.params.context.componentParent.startSource(data)
    setTimeout(()=>{
      this.innerClicked = false
    },500)
  }

  routeToDetails() {//console.log("rou")
    if (this.isDestinationSet) {
      let integration: IntegrationRef = {
        "integrationName": this.params.data.integrationName,
        "sourceId": this.params.data.sourceId,
        "status": this.params.data.status,
        "destinationName": this.params.data.destinationName
      }
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }
}
